import { getBenefitIdByTag, EVENT_TYPES } from '@/constants/benefitIds'
import { generateUnifiedDates } from '@/utils/eventDateFormatter/eventDateFormatter'
import { mapFormValuesToApiData } from '@/utils/eventMappers/eventMappers'
import { convertFromHTMLtoJson } from '@/utils/eventRegulationConverter/eventRegulationConverter'
import { businessUnit } from '@/utils/themes/theme'

/**
 * Extracts the image key from form values for a specific event type.
 * @param {Object} formValues - The form values containing image data.
 * @param {string} eventType - The event type to check against.
 * @returns {string|null} The image key (S3 key) or null.
 */
const extractImageKey = (formValues, eventType) => {
  if (formValues.type !== eventType || !formValues.image) {
    return null
  }

  return typeof formValues.image === 'object' && formValues.image.key ? formValues.image.key : formValues.image
}

/**
 * Prepares event data for submission to the API.
 * @param {Object} formValues - The form values from the event form.
 * @param {string|null} eventId - The ID of the event if editing, null for new events.
 * @param {boolean} isNewEvent - Whether this is a new event or an update.
 * @returns {Promise<Object>} The prepared data for API submission.
 */
export const prepareEventForSubmit = async (formValues, eventId, isNewEvent) => {
  const imageKey = extractImageKey(formValues, EVENT_TYPES.EXCLUSIVE_EVENTS)

  const benefitId = isNewEvent
    ? getBenefitIdByTag(formValues.type)
    : formValues.benefitId || getBenefitIdByTag(formValues.type)

  const businessUnitValue = businessUnit(globalThis.window?.location?.hostname)

  const rulesJson = convertFromHTMLtoJson(formValues.regulations, formValues.name, isNewEvent ? null : eventId)

  const formWithRules = {
    ...formValues,
    rules: rulesJson,
    unifiedDates: generateUnifiedDates(formValues.days)
  }

  return mapFormValuesToApiData(formWithRules, imageKey, benefitId, businessUnitValue, isNewEvent ? null : eventId)
}
